// Vue
import { Component, Prop, Vue } from "vue-property-decorator";
// Template
import template from "./template.vue";
import { BodyBuilder } from "../../../../common/interfaces/conversionworld/BodyBuilder";
import { ImageAspectRatio } from "../../../../components/image_aspect_ratio/ImageAspectRatio";

@Component({
  mixins: [template],
  components: {
    ImageAspectRatio,
  },
})
export class VanPartnerLink extends Vue {
  @Prop()
  public bodybuilder!: BodyBuilder;

  @Prop({ default: "default" })
  public theme!: string;

  get link() {
    if (this.bodybuilder.is_approved) {
      return this.bodybuilder.link;
    }

    return "#";
  }

  onClick(event) {
    if (!this.bodybuilder.is_approved) {
      event.preventDefault();
    }
  }
}
